// Golden and death crosses (DWLF-337): the fast SMA crossing the slow one, 50 over 200
// bars of whatever timeframe the chart shows. Offered only when both averages are switched
// on (and, like every event marker, only with indicator events shown). The detector is the
// library's `SMA.detectCrossoverEvents`, the one the jobs' smaCrossover runs on daily, with
// the same lengths, so a daily chart's markers match the stored events.
export const CROSSOVER_FAST = 50;
export const CROSSOVER_SLOW = 200;
export const CROSSOVER_META = { color: '#FFB300', displayName: 'Golden / Death Cross' };

/**
 * The crosses to draw in the visible window [from, to]. Detected over the FULL series, so a
 * short visible window (mobile's trailing year) still has the 200-bar warm-up behind it.
 */
export const goldenDeathCrossEvents = (SMA, { fullCandles, activeSMAs, from, to }) => {
  if (!activeSMAs?.has(CROSSOVER_FAST) || !activeSMAs.has(CROSSOVER_SLOW)) {
    return [];
  }
  const events = SMA.detectCrossoverEvents(fullCandles, { fast: CROSSOVER_FAST, slow: CROSSOVER_SLOW, source: 'close' });
  return events.filter((event) => (from === undefined || event.t >= from) && (to === undefined || event.t <= to));
};

// Close-confirmed reclaim / loss of the 50, 100 and 200 SMA (DWLF-448): the library's
// `SMA.detectReclaimEvents` with its defaults (2 closes, half an ATR), the one the jobs'
// smaReclaim runs on daily for these lengths. A daily chart's markers match the stored
// events once the chart's history reaches back past the first settled side; the first
// run in the loaded history fires nothing, so an early event can appear only after older
// candles load. Drawn for each of these averages that is switched on.
export const RECLAIM_LENGTHS = [50, 100, 200];

/**
 * The reclaim / loss events to draw in [from, to], as [{ period, events }] per active key
 * average. Detected over the FULL series, so the 200-bar warm-up sits behind a short window.
 */
export const smaReclaimEvents = (SMA, { fullCandles, activeSMAs, from, to }) => RECLAIM_LENGTHS
  .filter((period) => activeSMAs?.has(period))
  .map((period) => ({
    period,
    events: SMA.detectReclaimEvents(fullCandles, { length: period, source: 'close' })
      .filter((event) => (from === undefined || event.t >= from) && (to === undefined || event.t <= to)),
  }));
